import topics from "@/data/topics.json";

const strip = (html) => html.replace(/<br\s*\/?>/g, " ").replace(/<[^>]+>/g, "").replace(/&amp;/g, "&").replace(/\s+/g, " ").trim();

const clip = (text, max = 158) => {
  if (text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(" "))}…`;
};

export const cleanTitle = (t) => t.replace(/[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}]/gu, "").trim();

export const topicDescription = (t) => {
  const texts = t.blocks
    .filter((b) => b.type === "text" && !b.small)
    .map((b) => strip(b.html))
    .filter((s) => s.length > 60 && !/^https?:/.test(s));
  if (texts.length) return clip(texts[0]);
  return `${cleanTitle(t.title)}: articles, videos and resources on The Desi Science Page — science, skepticism and rational thinking.`;
};

export const topicSeo = (t) => {
  const firstImg = t.blocks.find((b) => b.type === "image")?.src;
  return {
    title: `${cleanTitle(t.title)} | The Desi Science Page`,
    description: topicDescription(t),
    path: `/${t.slug}`,
    image: t.cover || firstImg || "/og-image.jpg",
  };
};

export { topics };
